/**
 * Build-time item-card module discovery for the citizen workspace.
 * Static import.meta.glob patterns — no env var or codegen plugin required.
 *
 * Paths are relative to this file (src/config/) so Vite resolves them from the
 * citizen app root in dev/build and from helix-core unit tests via the /src alias.
 */
export const genericItemCardModules = import.meta.glob('../onify/citizen/components/item-cards/*.vue');

export const customerItemCardModules = import.meta.glob('../custom/components/item-cards/*/*.vue');
